import React from "react";
import Button from "components/elements/Button/Button";
import DynamicFontAwesomeIcon from "components/elements/DynamicFontAwesomeIcon";
import TicketItem from "../TicketItem";
import { formatCurrency } from "../checkoutHelpers";

/**
 * Component for displaying order items in the checkout
 */
const OrderItems = ({ 
	items, 
	currency, 
	isSubmitting, 
	expandedTickets, 
	formData, 
	formErrors,
	onTicketChange, 
	onClearError, 
	onQuantityChange, 
	onRemoveItem
}) => {
	return (
		<>
			{items.map((item, index) => (
				<div 
					key={item.id || index} 
					className="mb-3 pb-3 border-bottom border-white border-opacity-25"
					data-item-id={item.id}
					data-item-index={index}>
					<div className="row justify-content-between align-items-center">
						<div className="col-auto">
							<h5 className="fs-6 mb-1">{item.product_name}</h5>
							<p className="small opacity-75 mb-2">{item.description}</p>
						</div>
						<div className="col-auto">
							<div className="d-flex align-items-center mt-2">
								<Button
									variant="light"
									outline={true}
									size="sm"
									className="py-1 px-2"
									onClick={() => onQuantityChange(item.id, item.quantity - 1)}
									disabled={isSubmitting || item.quantity <= 1}
									title="Anzahl verringern"
									aria-label="Anzahl verringern">
									<DynamicFontAwesomeIcon 
										iconName="minus" 
										aria-hidden="true" 
									/>
								</Button>
								<span 
									className="mx-3 text-secondary-contrast"
									data-quantity={item.quantity}
									aria-live="polite">
									{item.quantity}
								</span>
								<Button
									variant="light"
									size="sm"
									className="py-1 px-2 me-3"
									onClick={() => onQuantityChange(item.id, item.quantity + 1)}
									disabled={isSubmitting}
									title="Anzahl erhöhen"
									aria-label="Anzahl erhöhen">
									<DynamicFontAwesomeIcon 
										iconName="plus" 
										aria-hidden="true" 
									/>
								</Button>
								<Button
									variant="light"
									outline={true}
									size="sm"
									className="py-1 px-2 me-3"
									onClick={() => onRemoveItem(item.id)}
									disabled={isSubmitting}
									title="Artikel entfernen"
									aria-label="Artikel entfernen">
									<DynamicFontAwesomeIcon 
										iconName="trash" 
										aria-hidden="true" 
									/>
								</Button>
								<div className="text-end">
									<span aria-label={`Preis: ${formatCurrency(item.price * item.quantity, currency)}`}>
										{formatCurrency(item.price * item.quantity, currency)}
									</span>
								</div>
							</div>
						</div>
					</div>

					{/* Ticket Assignment - Using the TicketItem component */}
					{expandedTickets
						.filter(ticket => ticket.baseItemId === item.id)
						.map(ticket => (
							<TicketItem
								key={ticket.id}
								ticket={ticket}
								formData={formData}
								formErrors={formErrors}
								onTicketChange={onTicketChange}
								onClearError={onClearError}
							/>
						))}
				</div>
			))}
		</>
	);
};

export default OrderItems;
